import React from 'react';
import PropTypes from 'prop-types';

export default class Icon extends React.Component {
  getRandomId = () =>
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15);

  render() {
    const props = {
      ...this.props,
      width: this.props.size,
      height: this.props.size,
    };
    return React.cloneElement(this.icon, props);
  }
}

Icon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

Icon.defaultProps = {
  size: 18,
  color: '#fff',
};
